import Vue from 'vue';
import CommonButton from '@/components/common/CommonButton.vue';
import CommonDialogue from '@/components/common/CommonDialogue.vue';
import FormApiErrorModal from '@/components/common/FormApiErrorModal.vue';
import PageCaption from '@/components/common/PageCaption.vue';
import YourDetailsStep from '@/components/steps/profile/YourDetailsStep.vue';
import useIsPageValid from '@/hooks/useIsPageValid';
import scrollToId from '@/hooks/scrollToId';
import { computed, ref, onMounted } from '@vue/composition-api';
import { Steps, Actions, Pages } from '@/util/settings/enums';
import config from '@/config';
export default Vue.extend({
    name: 'ProfilePage',
    components: {
        PageCaption,
        YourDetailsStep,
        CommonButton,
        CommonDialogue,
        FormApiErrorModal
    },
    setup(props, context) {
        const stepsData = {
            [Steps.PERSONAL_DETAILS]: {
                refName: Steps.PERSONAL_DETAILS,
                currentStepPath: Steps.PERSONAL_DETAILS,
                nextStepPath: Steps.PERSONAL_DETAILS_TWO
            }
        };
        const currentStep = computed(() => context.root.$route.params.step);
        const currentStaticRoute = computed(() => context.root.$route.name);
        const isPageValid = ref(true);
        const content = computed(() => context.root.$store.state.Content.content);
        const isFormApiLoading = computed(() => context.root.$store.state.Settings.isFormApiLoading);
        onMounted(() => {
            window.dataLayer.push({
                event: 'GMCC_Step_Personal_Details',
                category: 'GMC Online'
            });
        });
        const clickNext = () => {
            if (isFormApiLoading.value) {
                return;
            }
            const currentStepComponent = context.refs[Steps.PERSONAL_DETAILS];
            isPageValid.value = useIsPageValid(currentStepComponent.$refs);
            if (isPageValid.value) {
                context.root.$store.dispatch(Actions.SEND_FORM_DATA).then((response) => {
                    console.log(response.status);
                    if (response.status === 200) {
                        window.dataLayer.push({
                            event: 'GMCC_New_User_Form_Submit',
                            category: 'GMC Online'
                        });
                        window.location.href = config.url.siebel.siebelStepTwoUrl;
                    }
                    else {
                        window.dataLayer.push({
                            event: 'GMCC_New_User_Form_Submit_Error',
                            category: 'GMC Online'
                        });
                        scrollToId('page');
                    }
                }, (error) => {
                    window.dataLayer.push({
                        event: 'GMCC_New_User_Form_Submit_Error',
                        category: 'GMC Online'
                    });
                    scrollToId('page');
                    console.error(`error is ${error}`);
                });
            }
            else {
                scrollToId('c-dialogue-message');
            }
        };
        const clickBack = () => {
            if (window.history.length > 1) {
                context.root.$router.go(-1);
            }
            else {
                context.root.$router.push({ name: Pages.PROFILE });
            }
        };
        return {
            currentStep,
            currentStaticRoute,
            isPageValid,
            clickBack,
            clickNext,
            stepsData,
            Steps,
            content,
            isFormApiLoading,
            Pages
        };
    }
});
